import FolderTabs from "PFComponents/tabs/folder_tabs";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import css from "./booking_calendars.module.scss";
import { CalendarsController } from "./components/calendars/calendars_controller";
import { CalendarIcon, UserIcon } from "./components/icons";
import Workforce from "./components/workforce/workforce";
import { EditBookingCalendarController } from "./edit_booking_calendar/edit_booking_calendar_controller";
import { NewBookingCalendar } from "./new_booking_calendar/new_booking_calendar";

enum Tabs {
  Calendars = "CALENDARS",
  Workforce = "WORKFORCE"
}

const BookingCalendars = () => {
  const { path } = useRouteMatch();
  const [tabId, setTabId] = useState();
  const { t } = useTranslation("bookingModule");

  const handleTabChange = (_, id) => setTabId(id);

  return (
    <Switch>
      <Route exact path={path}>
        <FolderTabs
          onTabSelected={handleTabChange}
          tabs={[
            {
              id: Tabs.Calendars,
              displayElement: (
                <div className={css.tab}>
                  <div>
                    <CalendarIcon width={20} height={20} />
                  </div>
                  <div>{t("config.calendars.title")}</div>
                </div>
              ),
              Content: <CalendarsController />
            },
            {
              id: Tabs.Workforce,
              displayElement: (
                <div className={css.tab}>
                  <div>
                    <UserIcon width={20} height={20} />
                  </div>
                  <div>{t("config.calendars.workforce.title")}</div>
                </div>
              ),
              Content: <Workforce />
            }
          ]}
          selectedTabId={tabId}
        />
      </Route>
      <Route path={`${path}/new`}>
        <NewBookingCalendar />
      </Route>
      <Route path={`${path}/:id`}>
        <EditBookingCalendarController />
      </Route>
    </Switch>
  );
};

export default BookingCalendars;
